import React from 'react'
import { BsArrowRight } from 'react-icons/bs'

const CtaSection = () => {
  return (
    <div>
         <section className="bg-gradient-to-br from-slate-100 to-blue-50 py-20">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl font-bold text-slate-900 mb-6">Ready to get started?</h2>
        <p className="text-xl text-slate-600 mb-8">
          Empower your digital journey and unlock limitless potential through strategic talent partnerships.
        </p>
        <button className="bg-cyan-500 hover:bg-cyan-600 text-white px-8 py-4 rounded-lg font-semibold flex items-center space-x-2 mx-auto transition-colors">
          <span>Connect With Us</span>
          <BsArrowRight className="w-5 h-5" />
        </button>
      </div>
    </section>
    </div>
  )
}

export default CtaSection